import { ICD_DESCRIPTION_LOADING_PLACEHOLDER } from "../../constants";
import { TableData } from "../../types";
import { ENTER_MANUALLY_OPTION, NONE_OF_THE_ABOVE_OPTION } from "./constants";

/** Manual-entry values supplied when {@link ENTER_MANUALLY_OPTION} is selected. */
export interface HandleSaveSelectionContext {
  manualPrimaryCode?: string;
  manualPrimaryCodeDescription?: string;
}

/**
 * Resolves the ICD code and description to persist for the current selection.
 *
 * @param selectedPrimaryCode - Dropdown value chosen by the user.
 * @param tableData - Patient Dx rows shown in the modal table.
 * @param selectionContext - Manual-entry values when applicable.
 * @return Resolved ICD payload, or `null` when the selection cannot be saved.
 */
export const resolvePrimaryDiagnosisForSave = (
  selectedPrimaryCode: string,
  tableData: TableData[],
  selectionContext?: HandleSaveSelectionContext,
): { icdCode: string; icdDescription: string } | null => {
  if (selectedPrimaryCode === NONE_OF_THE_ABOVE_OPTION) {
    return { icdCode: "", icdDescription: "" };
  }

  if (selectedPrimaryCode === ENTER_MANUALLY_OPTION) {
    const icdCode = selectionContext?.manualPrimaryCode?.trim() ?? "";
    if (!icdCode) {
      return null;
    }

    const rawDescription = selectionContext?.manualPrimaryCodeDescription ?? "";
    const icdDescription =
      rawDescription === ICD_DESCRIPTION_LOADING_PLACEHOLDER
        ? ""
        : rawDescription;
    return { icdCode, icdDescription };
  }

  const selectedEntry = tableData.find(
    (entry) => entry.icd10_code === selectedPrimaryCode,
  );
  if (!selectedEntry) {
    return null;
  }

  return {
    icdCode: selectedEntry.icd10_code || "",
    icdDescription: selectedEntry.icd10_desc || "",
  };
};
